/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const ADMIN_EMAILS = [
  'matthieup03@gmail.com',
];

export default function AdminLoginPage({ onAdminAccess }) {
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user) {
        const email = session.user.email;
        if (ADMIN_EMAILS.includes(email)) {
          onAdminAccess();
        } else {
          await supabase.auth.signOut();
          setError(`Le compte ${email} n'est pas autorisé.`);
        }
      }
      setChecking(false);
    };

    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === 'SIGNED_IN' && session?.user) {
        setLoading(true);
        const email = session.user.email;
        if (ADMIN_EMAILS.includes(email)) {
          onAdminAccess();
        } else {
          await supabase.auth.signOut();
          setError(`Le compte ${email} n'est pas autorisé à accéder au back-office.`);
          setLoading(false);
        }
      }
    });

    checkSession();
    return () => subscription.unsubscribe();
  }, [onAdminAccess]);

  const handleGoogle = async () => {
    setLoading(true);
    setError(null);
    localStorage.setItem('admin_redirect', '1');
    sessionStorage.setItem('admin_pending', '1');
    const { error: oauthErr } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: 'https://www.havenly.fr/?admin=back-office-hv',
        queryParams: { prompt: 'select_account' },
      },
    });
    if (oauthErr) {
      setError(oauthErr.message);
      setLoading(false);
    }
  };

  if (checking) return (
    <div style={{ minHeight: '100vh', background: '#0F1A16', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.3)' }}>Vérification...</div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#0F1A16', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <div style={{ position: 'fixed', inset: 0, opacity: 0.04, backgroundImage: 'linear-gradient(#1D9E75 1px, transparent 1px), linear-gradient(90deg, #1D9E75 1px, transparent 1px)', backgroundSize: '40px 40px', pointerEvents: 'none' }} />

      <div style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 20, padding: '2.5rem 2rem', width: '100%', maxWidth: 400, backdropFilter: 'blur(10px)', position: 'relative', zIndex: 1, textAlign: 'center' }}>

        <div style={{ marginBottom: 32 }}>
          <svg viewBox="0 0 210 52" style={{ height: 28, width: 'auto' }} xmlns="http://www.w3.org/2000/svg">
            <text x="0" y="44" fontFamily="Georgia,serif" fontSize="52" fontWeight="400" fontStyle="italic" letterSpacing="-2" fill="#fff">haven<tspan fill="#1D9E75" dx="-3">ly</tspan></text>
          </svg>
          <div style={{ display: 'inline-block', marginTop: 12, background: 'rgba(29,158,117,0.15)', border: '1px solid rgba(29,158,117,0.3)', color: '#1D9E75', fontSize: 11, fontWeight: 500, padding: '3px 12px', borderRadius: 20, letterSpacing: '1px', textTransform: 'uppercase' }}>
            Back office
          </div>
        </div>

        <h2 style={{ fontFamily: 'Georgia, serif', fontSize: 22, color: '#fff', marginBottom: 6, letterSpacing: '-0.3px' }}>Accès restreint</h2>
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', marginBottom: 32 }}>Réservé aux administrateurs Havenly</p>

        {error && (
          <div style={{ background: 'rgba(163,45,45,0.15)', border: '1px solid rgba(240,149,149,0.3)', borderRadius: 10, padding: '10px 14px', marginBottom: 20, fontSize: 13, color: '#F09595', textAlign: 'left' }}>
            {error}
          </div>
        )}

        <button onClick={handleGoogle} disabled={loading}
          style={{ width: '100%', padding: '13px', background: 'rgba(255,255,255,0.08)', color: '#fff', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 12, fontSize: 14, fontWeight: 500, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'sans-serif', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
          {loading ? (
            <span style={{ opacity: 0.5 }}>Connexion en cours...</span>
          ) : (
            <>
              <svg width="18" height="18" viewBox="0 0 18 18">
                <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
                <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" fill="#34A853"/>
                <path d="M3.964 10.707A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.707V4.961H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.039l3.007-2.332z" fill="#FBBC05"/>
                <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.961L3.964 7.293C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
              </svg>
              Continuer avec Google
            </>
          )}
        </button>

        <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.15)', marginTop: 28 }}>
          Cette page n'est pas référencée et ne doit pas être partagée.
        </p>
      </div>
    </div>
  );
}